import React, { useEffect, useState } from 'react';
import Table from '../../components/Table';
import LeadService from '../../core/services/leadsService';
import { useNavigate } from 'react-router-dom';
import BasicSelect from '../../components/common/Select';
import { Paper, Stack } from '@mui/material';

const column = [
    {
        accessorKey: 'first_name',
        header: 'Name',
        size: 150,
        enableFilters: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        showColumnFilters: false,
        // enableGlobalFilter: fales
    },
    {
        accessorKey: 'email',
        header: 'Email',
        size: 150,
        enableFilters: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        showColumnFilters: false,
    },
    {
        accessorKey: 'lead_type',
        header: 'Lead Type',
        size: 150,
        enableColumnActions: false,
        enableFilters: false,
        enableColumnFilter: false,
        showColumnFilters: false,
        // filterFn: 'equals',
        // filterSelectOptions: ['Buyer', 'Female', 'Other'],
        // filterVariant: 'select',
    },
    {
        accessorKey: 'phone',
        header: 'Phone',
        size: 150,
        enableFilters: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        showColumnFilters: false,
    },
    {
        accessorKey: 'property_type',
        header: 'Property Type',
        size: 150,
        enableColumnActions: false,
        filterFn: 'equals',
        filterSelectOptions: ['House', 'Other'],
        filterVariant: 'select',
        enableColumnActions: false,
        enableFilters: false,
        enableColumnFilter: false,
        showColumnFilters: false,
    },
    {
        accessorKey: 'source',
        header: 'Source',
        size: 150,
        enableColumnActions: false,
        filterFn: 'equals',
        filterSelectOptions: ['Zillow', 'Facebook', 'Other'],
        filterVariant: 'select',
        enableColumnActions: false,
        enableFilters: false,
        enableColumnFilter: false,
        showColumnFilters: false,
    },
    {
        accessorKey: 'status',
        header: 'Status',
        enableColumnActions: false,
        showColumnFilters: true,
        size: 150,
        enableColumnFilters: true,
        enableFacetedValues: true,
        enableFilters: true,
        showColumnFilters: true,
        filterFn: 'equals',
        filterSelectOptions: ['Buyer', 'Other'],
        filterVariant: 'select',
        enableColumnActions: false,
        enableFilters: false,
        enableColumnFilter: false,
        showColumnFilters: false,
    },
];

const People = () => {
    const [leads, setLeads] = React.useState([]);
    const [filtersData, setFilterData] = React.useState({});
    const [filters, setFilters] = useState({});
    const navigate = useNavigate();

    const getISAAgents = async (filters) => {
        try {
            const res = await LeadService.getAdminLeadsApi(filters);
            if (res?.data?.success) {
                setLeads(res?.data['leads']);
                return;
            }
        } catch (error) {
            setLeads([]);
            // toast.error("Failed to get isa-leads.")
            console.error(error);
        }
    };

    const handleFilters = (value, name) => {
        setFilters((prev) => {
            return {
                ...prev,
                [name]: value === 'all' ? '' : value,
            };
        });
    };

    useEffect(() => {
        getISAAgents(filters);
    }, [filters]);

    useEffect(() => {
        getISAAgents();
        LeadService.getLeadSearchDataApi()
            .then((res) => {
                let shapedData = { lead_type: [], sources: [], status: [] };
                const data = res.data;
                ['lead_type', 'sources', 'status'].forEach((item) => {
                    data[item]?.forEach((type, index) => {
                        if (index === 0) {
                            shapedData[item].push({
                                value: 'all',
                                text: 'All',
                            });
                        }
                        shapedData[item].push({
                            value: type,
                            text: type,
                        });
                    });
                });

                setFilterData(shapedData);
            })
            .catch();
    }, []);

    return (
        <>
            <Paper sx={{ px: 1, py: 0.1 }}>
                <Stack my={3} direction={'row'} spacing={2}>
                    <BasicSelect
                        onChange={(val) => handleFilters(val, 'lead_type')}
                        label="Lead Type"
                        name="lead_type"
                        data={filtersData?.lead_type}
                    />
                    <BasicSelect onChange={(val) => handleFilters(val, 'status')} label="Status" name="status" data={filtersData?.status} />
                    <BasicSelect onChange={(val) => handleFilters(val, 'source')} label="Source" name="source" data={filtersData?.sources} />
                </Stack>
            </Paper>
            <Table type="people" onRowClick={(row) => navigate(`/isa-agent-details/${row.original.id}`)} column={column} data={leads} />
        </>
    );
};

export default People;
